// extracted by mini-css-extract-plugin
module.exports = {"activityListTitle":"_125fn","activitiesCustomScrollbar":"FXpbA"};